import axiosClient from "./axiosClient";

export const listarMonedas = () => axiosClient.get("/monedas").then((r) => r.data);
export const upsertMoneda = (data) => axiosClient.post("/monedas", data).then((r) => r.data);
export const eliminarMoneda = (id) => axiosClient.delete(`/monedas/${id}`);

// Moneda predeterminada por familia (solo Mantenimiento).
export const listarFamiliasMoneda = () => axiosClient.get("/monedas/familias").then((r) => r.data);
export const cambiarMonedaFamilia = (familiaId, monedaId) => axiosClient.put(`/monedas/familias/${familiaId}`, { monedaId });
